import React, { useState, useEffect } from "react";
import Loading from "../components/Loading";
import RegistrationMap from "../components/RegistrationMap";
import LoadCountriesTaskRegistration from "../tasks/LoadCountriesTaskRegistration";
import RegistrationlegendItems from "../entities/RegistrationLegendItems";
import ReactGA from 'react-ga';

const TRACKING_ID ="G-2D7RRR14SS";
ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);


function EaseOfRegistration() {
  const [countries, setCountries] = useState([]);

  const legendItemsReverse = [...RegistrationlegendItems].reverse();

  const load = () => {
    console.log("load");
    const loadCountriesTask = new LoadCountriesTaskRegistration();
    loadCountriesTask.load((countries) => setCountries(countries));
  };
  console.log(countries)

  useEffect(load, []);

  return (
    <div>
      {countries.length === 0 ? (
        <Loading />
      ) : (
        <div >
          <RegistrationMap
 countries={countries} />
          
        </div>
      )}
    </div>
  );
};


export default EaseOfRegistration